
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 1l18 18","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.5 17H1.6a.6.6 0 01-.6-.6V7h6.5","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.5 17H1.6a.6.6 0 01-.6-.6V7h6.5M1 7V3.6a.6.6 0 01.6-.6h1.9","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M13 7h8v8","fill":"#fff"}}),_c('path',{attrs:{"d":"M13 7h8v8l-8-8zM21 7V3.6a.6.6 0 00-.6-.6H9","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    